import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import ArticleList from './components/ArticleList';

export default function Home() {
  useEffect(() => {
    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'aaa一级日韩',
      url: 'https://aaa-rikhan.example.com/',
      description: '最新最全的日本韩国影视娱乐资讯平台。每日更新日剧韩剧推荐、K-POP与J-POP音乐、综艺节目与明星动态。',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://aaa-rikhan.example.com/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    };

    const orgSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'aaa一级日韩',
      url: 'https://aaa-rikhan.example.com/',
      description: '专注于日韩影视娱乐内容的综合资讯平台',
      sameAs: [
        'https://weibo.com/aaa-rikhan',
        'https://space.bilibili.com/aaa-rikhan',
      ],
    };

    const scripts = [
      JSON.stringify(jsonLd),
      JSON.stringify(orgSchema),
    ];

    scripts.forEach((s) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = s;
      document.head.appendChild(script);
    });

    return () => {
      document.head.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
        if (scripts.some((s) => el.textContent === s)) {
          el.remove();
        }
      });
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <FeaturedSection />
        <CategorySection />
        <ArticleList />
      </main>
      <Footer />
    </>
  );
}